export type ViewportFormFactor = 'desktop' | 'phone' | 'tablet' | undefined

export type EditorInitialFocus = 'default' | 'first-line-end' | 'none'

/**
 * A phone opening an existing note starts in a readable, keyboard-closed state.
 * New notes still use the default text-ready focus path.
 */
export function shouldAutofocusExistingNote(formFactor: ViewportFormFactor): boolean {
  return formFactor !== 'phone'
}

export function editorInitialFocusForEntry({
  formFactor,
  isExistingNote,
  isRoutedNoteOpen,
  readingScreenshots = false,
}: {
  formFactor: ViewportFormFactor
  isExistingNote: boolean
  isRoutedNoteOpen: boolean
  /** Screenshots arrived and Unpack is reading them: a phone shows them being read, keyboard closed, until the person taps to write. */
  readingScreenshots?: boolean
}): EditorInitialFocus {
  if ((isExistingNote || isRoutedNoteOpen || readingScreenshots) && !shouldAutofocusExistingNote(formFactor)) return 'none'
  return isRoutedNoteOpen ? 'first-line-end' : 'default'
}

/** Passive navigation restores reading position, not the touch keyboard. */
export function shouldRestoreBrowseInputFocus(formFactor: ViewportFormFactor): boolean {
  return formFactor === 'desktop'
}
